enum NavigationTabType {
    home,
    work,
    articles
}

export default NavigationTabType;
